<template>
  <div class='table-box'>
    <global-tag>
      <el-form label-width='120px'>
        <el-row>
          <el-col :span='6'>
            <el-form-item label='坐席编号:'>
              <el-select
                v-model='searchObj.seatNo'
                placeholder='请选择'
              >
                <el-option
                  v-for='item in serviceTypeList'
                  :key='item.id'
                  :label='item.serviceTypeName'
                  :value='item.id'
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='6'>
            <el-form-item label='区域：'>
              <el-input
                clearable
                placeholder='请输入'
                v-model='searchObj.serviceProductName'
                size='primary'
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='3' :offset='2'>
            <el-button
              type='primary'
              size='medium'
              class='searchBtns'
              @click='getTableData'
            >查询
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </global-tag>

    <el-button
      icon='el-icon-plus'
      class='openBtns'
      style='margin: 10px 0'
      type='success'
      size='medium'
      @click="showDialog('新增', '')"
    >
      新增
    </el-button>

    <el-table
      :data='tableData'
      border
      style='width: 100%; margin-bottom: 15px'
      ref='addForm'
      :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
    >
      <el-table-column
        type='index'
        width='70'
        label='序号'
        align='center'
        :show-overflow-tooltip='true'
      >
      </el-table-column>
      <el-table-column
        prop='seatNo'
        label='坐席编号'
        align='center'
        :show-overflow-tooltip='true'
      >
      </el-table-column>
      <el-table-column
        prop='loginName'
        label='登录名'
        align='center'
        :show-overflow-tooltip='true'
      >
      </el-table-column>
      <el-table-column
        prop='orgName'
        label='机构'
        align='center'
        :show-overflow-tooltip='true'
      >
      </el-table-column>
      <!-- <el-table-column
          prop="seatChannel"
          label="坐席通道"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="servicePrice"
          label="服务价格"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="ACD_IP"
          label="ACD服务区IP"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="ACD_port"
          label="ACD服务区端口"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="businessNo"
          label="业务组号"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="skillLevel"
          label="技能级别"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="permissions"
          label="坐席权限"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="orgName"
          label="机构"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column> -->
      <el-table-column label='操作' align='center' width='150'>
        <template slot-scope='scope'>
          <!-- <el-button
              @click="showDialog('查看', scope.row)"
              type="text"
              >查看
          </el-button> -->
          <el-button
            @click="showDialog('编辑', scope.row)"
            type='text'
          >编辑
          </el-button>
          <el-button
            @click='
                            deleteItem(
                                scope.row.id,
                                scope.row.loginId,
                                scope.row.seatNo
                            )
                        '
            type='text'
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      @size-change='handleSizeChange'
      @current-change='handleCurrentChange'
      :current-page='pageConfig.pageNo'
      :page-sizes='[5, 10, 20, 50]'
      :page-size='pageConfig.pageSize'
      layout='total, sizes, prev, pager, next, jumper'
      :total='pageConfig.total'
    >
    </el-pagination>

    <!-- 表单弹框-->
    <el-dialog
      :title='dialogTitle'
      :visible.sync='dialogVisible'
      width='40%'
      :close-on-click-modal='false'
      :before-close='handleClose'
    >
      <el-form
        :disabled="dialogTitle === '查看'"
        :model='addForm'
        :rules='rules'
        ref='addForm'
        label-width='120px'
      >
        <div style='display: flex; justify-content: space-between'>
          <div>
            <el-form-item label='登陆名:' prop='loginName'>
              <el-select
                style='width: 100%'
                v-model='addForm.loginName'
                placeholder='请选择'
                @change='adminSelect($event)'
              >
                <el-option
                  v-for='item in serviceTypeList'
                  :key='item.id'
                  :label='item.loginName'
                  :value='{
                                        personsName: item.loginName,
                                        personsId: item.id,
                                        orgId: item.orgId,
                                    }'
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label='坐席编号:' prop='seatNo'>
              <el-input
                v-model='addForm.seatNo'
                placeholder='请输入'
              ></el-input>
            </el-form-item>
            <!-- <el-form-item
                label="坐席通道:"
                prop="serviceProductName"
            >
                <el-input
                    v-model="addForm.seatChannel"
                    placeholder="请输入"
                ></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="ACD服务器IP:" prop="servePrice">
                <el-input
                    v-model="addForm.ACD_IP"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="坐席技能级别:" prop="servePrice">
                <el-input
                    v-model="addForm.skillLevel"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="机构选择:" prop="orgsId">
                <el-cascader
                    :key="isRescourceShow"
                    :options="orgTree"
                    v-model="addForm.orgsId"
                    :show-all-levels="false"
                    :props="{
                        checkStrictly: true,
                        emitPath: false,
                        label: 'label',
                        value: 'orgId',
                    }"
                    clearable
                >
                </el-cascader>
            </el-form-item>
        </div>
        <div>
            <el-form-item label="坐席编号:" prop="servePrice">
                <el-input
                    v-model="addForm.seatNo"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="业务组号:" prop="servePrice">
                <el-input
                    v-model="addForm.businessNo"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="ACD服务器端口:" prop="servePrice">
                <el-input
                    v-model="addForm.ACD_port"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="坐席权限:" prop="servePrice">
                <el-input
                    v-model="addForm.permissions"
                    placeholder="请输入"
                ></el-input>
            </el-form-item> -->
          </div>
        </div>
      </el-form>
      <div
        v-if="dialogTitle !== '查看'"
        style='
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 15px;
                '
      >
        <el-button @click='send' type='primary'>确定</el-button>
        <el-button @click='handleClose' type='info'>取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headLine from '../components/headline'
import { post } from '@/api/requrestHttp'

export default {
  components: {
    headLine
  },
  data() {
    return {
      // 服务类别列表
      serviceTypeList: [],
      // 图片上传地址
      searchObj: {
        serviceTypeId: '',
        serviceProductName: ''
      },
      isRescourceShow: 0,
      dialogTitle: '',
      dialogVisible: false,
      editId: '',
      addForm: {
        loginName: '',
        seatNo: '',
        serviceTypeId: '',
        serviceProductName: '',
        servePrice: '',
        status: '1',
        productPhoto: ''
      },
      defaultProps: {
        checkStrictly: true,
        value: 'orgId',
        label: 'label'
      },
      rules: {
        loginName: [
          {
            required: true,
            message: '登录名不能为空',
            trigger: 'blur'
          }
        ],
        seatNo: [
          {
            required: true,
            message: '坐席编号不能为空',
            trigger: 'blur'
          }
        ]
        // status: [
        //     { required: true, message: "请选择状态", trigger: "blur" },
        // ],
      },
      tableData: [],
      orgTree: [],
      // 分页
      pageConfig: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  watch: {
    orgTree() {
      ++this.isRescourceShow

      console.log(this.isRescourceShow)
    }
  },
  created() {
    this.getTableData()
    this.getOrgTree()
    this.addForm = {
      loginName: '',
      seatNo: ''
    }
    this.$http
      .request({
        url: '/rbac/admin/user/info/list',
        method: 'POST',
        data: {
          pageNo: 1,
          pageSize: 1000,
          userType: 1
        }
      })
      .then((res) => {
        if (res.code === 200) {
          this.serviceTypeList = res.content.list
          console.log(this.serviceTypeList)
        }
      })
  },
  methods: {
    // 获取机构树
    async getOrgTree() {
      const { content } = await post(
        '/rbac/admin/org/info/OrgTreeForOrgIdlist',
        {
          isValid: 1
        }
      )
      console.log(content)
      this.orgTree = content
      console.log(this.orgTree)
    },
    adminSelect(event) {
      console.log(event)
      this.addForm.loginId = event.personsId
      this.addForm.loginName = event.personsName
      this.addForm.orgId = event.orgId
    },
    // 提交
    send() {
      this.$refs.addForm.validate((valid) => {
        // 校验通过
        if (valid) {
          // if (
          //   Array.isArray(this.addForm.orgId) &&
          //   this.addForm.orgId.length > 0
          // ) {
          //   this.addForm.orgId =
          //     this.addForm.orgId.pop()
          // } else {
          //   this.addForm.orgId = ""
          // }
          let data = {
            // serviceTypeId: this.addForm.serviceTypeId,
            // status: this.addForm.status,
            // productPhoto: this.addForm.productPhoto,
            // serviceProductName: this.addForm.serviceProductName,
            ...this.addForm
          }

          if (this.editId) {
            data.id = this.editId
          }
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          this.$http
            .request({
              url: '/jjyl/seatConfig/info/save',
              method: 'POST',
              data: data
            })
            .then((res) => {
              if (res.code == 200) {
                loading.close()
                this.$message.success('操作成功')
                if (res.content.isMine == true) {
                  this.$store.commit(
                    'setNo',
                    res.content.seatNo
                  )
                }
                this.editId = ''
                this.getTableData()
                this.handleClose()
              } else {
                loading.close()
              }
            }).catch((error) => {
            loading.close()
            this.handleClose()

          })
        }
      })
    },
    // 删除某一项
    deleteItem(id, loginId, seatNo) {
      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http
          .request({
            url: '/jjyl/seatConfig/info/delete',
            method: 'POST',
            data: {
              id,
              loginId,
              seatNo
            }
          })
          .then((res) => {
            if (res.code == 200) {
              if (res.content.isMine == true) {
                this.$store.commit('setNo', '')
              }
              this.$message.success('删除成功')
              this.getTableData()
            }
          })
      })
    },
    // 显示弹框
    showDialog(title, row) {
      this.dialogTitle = title
      this.dialogVisible = true
      if (title == '新增') {
        this.addForm = {
          loginName: '',
          serviceTypeId: '',
          serviceProductName: '',
          servePrice: '',
          status: '1',
          productPhoto: ''
        }
      }

      if (title != '新增') {
        this.addForm = JSON.parse(JSON.stringify(row))
        // this.addForm.seatNo = row.seatNo
        // this.addForm.id = row.id
        // if (row.id) {
        //     this.editId = row.id
        // }
        // this.$http
        //     .request({
        //         url: "/jjyl/admin/product/info/findById",
        //         method: "POST",
        //         data: {
        //             id: row.id,
        //         },
        //     })
        //     .then((res) => {
        //         if (res.code === 200) {
        //             this.addForm = res.content || {}
        //         }
        //     })
      }
    },
    // 关闭弹框
    handleClose() {
      this.dialogVisible = false
      this.addForm = {}
      this.$refs.addForm.resetFields()
      // this.getTableData()
    },

    // 获取列表数据
    getTableData() {
      this.$http
        .request({
          url: '/jjyl/seatConfig/info/findList',
          method: 'POST',
          data: {
            pageNo: this.pageConfig.pageNo,
            pageSize: this.pageConfig.pageSize
            // serviceTypeId: this.searchObj.serviceTypeId,
            // serviceProductName: this.searchObj.serviceProductName
          }
        })
        .then((res) => {
          if (res.code == 200) {
            if (!res.content) {
              this.tableData = []
              this.pageConfig.total = 0
            } else {
              this.tableData = res.content.list || []
              this.pageConfig.total = res.content.count || 0
            }
          }
        })
    },
    // 每页显示条数切换
    handleSizeChange(val) {
      this.pageConfig.pageSize = val
      this.getTableData()
    },
    // 页码切换
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 100px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .avatar {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;

    img {
      width: 100px;
      height: 100px;
      line-height: 100px;
      display: block;
    }
  }
}
</style>
